var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChevronEnd = function SvgChevronEnd(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m3.273 11.15 3.75-3.75a.56.56 0 0 0 0-.794l-3.75-3.752a.562.562 0 0 0-.795.795l3.352 3.35-3.353 3.355a.562.562 0 0 0 .795.794zm4.5 0 3.75-3.75a.56.56 0 0 0 0-.794l-3.75-3.752a.562.562 0 0 0-.795.795l3.353 3.35-3.354 3.355a.562.562 0 0 0 .795.794z"
  })));
};
export default SvgChevronEnd;